/**
 * ClientsLegacyRedirect — redirige /admin/clients vers les dossiers Master :
 *   - /admin/clients              → /admin/masters
 *   - /admin/clients?open=<cid>   → /admin/masters?open=<cid> (ouvre la fiche)
 */
import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

export default function ClientsLegacyRedirect() {
  const navigate = useNavigate();
  const [params] = useSearchParams();

  useEffect(() => {
    const openId = params.get("open");
    if (openId) {
      navigate(`/admin/masters?open=${openId}`, { replace: true });
    } else {
      navigate("/admin/masters", { replace: true });
    }
  }, [navigate, params]);

  return null;
}
